import React, { useState } from 'react';
import { ArrowRight, CheckCircle2, Sparkles, ShieldCheck, Mail } from 'lucide-react';
import { InteractiveHeroShowcase } from './InteractiveHeroShowcase';

interface HeroSectionProps {
  onOpenBriefing: () => void;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ onOpenBriefing }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onOpenBriefing();
  };

  return (
    <section className="relative pt-24 pb-20 px-4 md:px-12 bg-white text-slate-900 font-sans overflow-hidden border-b border-slate-200/60">
      
      {/* Background Subtle Gradient Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1200px] h-[600px] bg-gradient-to-b from-blue-50/60 via-slate-50/40 to-transparent blur-[120px] pointer-events-none -z-10" />

      <div className="max-w-7xl mx-auto space-y-16 text-center">
         
         {/* HERO EDITORIAL HEADLINE CONTAINER (GOOGLE / THE BRAVA STYLE) */}
         <div className="max-w-4xl mx-auto space-y-6">
            
            {/* Top Pill Badge */}
            <div className="inline-flex items-center gap-2 bg-slate-100 text-slate-800 px-4 py-1.5 rounded-full text-xs font-bold border border-slate-200 shadow-xs">
               <Sparkles className="w-3.5 h-3.5 text-[#0061FF]" />
               YOUMACHINE • ECOSSISTEMA DIGITAL 360°
            </div>

            {/* Headline */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black tracking-tight text-slate-900 leading-[1.06]">
               Tudo o que sua empresa precisa para <span className="bg-gradient-to-r from-[#0061FF] via-blue-700 to-slate-900 bg-clip-text text-transparent">vender e dominar</span> no digital.
            </h1>

            {/* Subtitle */}
            <p className="text-slate-600 text-lg md:text-xl font-normal leading-relaxed max-w-2xl mx-auto">
               Unifique seu site, aplicativos de delivery PWA sem taxas, ficha no Google Meu Negócio e gestão de anúncios em uma única infraestrutura.
            </p>

            {/* EMAIL CAPTURE FORM */}
            <form onSubmit={handleSubmit} className="pt-2 max-w-md mx-auto space-y-4">
               <div className="flex flex-col sm:flex-row gap-2.5 bg-slate-50 border border-slate-300/80 p-2 rounded-2xl shadow-xs focus-within:border-[#0061FF] focus-within:ring-2 focus-within:ring-[#0061FF]/10 transition-all">
                  <div className="flex-1 flex items-center px-3 gap-2">
                     <Mail className="w-5 h-5 text-slate-400" />
                     <input 
                        type="email" 
                        required 
                        placeholder="Seu e-mail corporativo..." 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full bg-transparent outline-none text-sm text-slate-900 placeholder:text-slate-400 font-medium"
                     />
                  </div>
                  <button 
                     type="submit" 
                     className="bg-[#0061FF] hover:bg-blue-700 text-white font-black text-xs uppercase tracking-wider px-6 py-3.5 rounded-xl transition-all shadow-xs flex items-center justify-center gap-2 shrink-0"
                  >
                     <span>Conhecer Ecossistema</span>
                     <ArrowRight className="w-4 h-4" />
                  </button>
               </div>
            </form>

            {/* Micro Trust Indicators */}
            <div className="flex flex-wrap items-center justify-center gap-6 text-xs font-semibold text-slate-500 pt-2">
               <span className="flex items-center gap-1.5">
                  <CheckCircle2 className="w-4 h-4 text-emerald-500" /> Implantação sem complicações
               </span>
               <span className="flex items-center gap-1.5">
                  <CheckCircle2 className="w-4 h-4 text-emerald-500" /> 0% de comissão sobre vendas
               </span>
               <span className="flex items-center gap-1.5">
                  <CheckCircle2 className="w-4 h-4 text-emerald-500" /> Suporte VIP 24/7
               </span>
            </div>

         </div>

         {/* HERO LIVE SHOWCASE DISPLAY (INTERACTIVE TABS) */}
         <div className="pt-4">
            <InteractiveHeroShowcase />
         </div>

      </div>
    </section>
  );
};
